import { Injectable } from '@angular/core';
import { ToastController } from 'ionic-angular';
import { Http } from '@angular/http';

import { UserData } from './user-data';
import { CommonData } from '../providers/common-data';
import { NativeScriptHttpModule } from "nativescript-angular/http";

@Injectable()
export class EinsatzplanData {
  data: any;
  datastatus_0:any;
  datastatus_1:any;
  dataextended:any;
  datatoday: any;
  viewmode:string;
  updateRequired:boolean;
  constructor(public http: Http
            , public common: CommonData
            , public userData: UserData
            , public toastCtrl: ToastController
            ) {}
  clear(){
    if(this.data!=null){
      this.data.length = 0;
    }
  }
  load() {
    return new Promise(resolve => {
      if(this.userData.loggedin){
        this.http.get(this.common.baseurl+'einsatzplane/getassigned?mode='+this.viewmode+'&token='+this.userData.jwt).subscribe(res => {
          
          this.data = res.json().data;
          this.updateRequired = false;
          resolve("");
        }, error => {
          console.log('HTTP Error, no answer ep-data.ts');
          console.log(error);
      });

      }
    });
  }
  getToday(){
    return new Promise(resolve => {
      if(this.userData.loggedin){
        this.http.get(this.common.baseurl+'einsatzplane/getassigned?mode=today&token='+this.userData.jwt).subscribe(res => {
          
          this.datatoday = res.json().data;
          //console.log(this.datatoday);
          this.updateRequired = false;
          resolve("");
        }, error => {
          console.log('HTTP Error, no answer ep-data.ts');
          console.log(error);
      });

      }
    });
  }

  createmultiple(data){
    return new Promise(resolve => {

      this.http.post(this.common.baseurl+'einsatzplane/createmultiple',data)
        .subscribe(data => {
          let response = data.json();
          //console.log(response);
          this.updateRequired = true;
          if(response.success === true){
            this.updateRequired = true;
            this.dataextended = response.data;
          }
          else{
            
            let toast = this.toastCtrl.create({
              message: 'Fehler erzeugen des Einsatzplan',
              position: 'top',
              cssClass: 'toast-error',
              duration: 3000
            });
            toast.present();     
                  
            //console.log("fehler");
          }
        resolve(response.data);          
        }, error => {
          console.log('HTTP Error, no answer');
          console.log(error);
      });
    });    
  }

  
  createmanual(data){
    return new Promise(resolve => {

      this.http.post(this.common.baseurl+'einsatzplane/createmanual',data)
        .subscribe(data => {
          let response = data.json();
          //console.log(response);
          //this.updateRequired = true;
          if(response.success === true){
            this.updateRequired = true;
            this.dataextended = JSON.parse(response.data);
          }
          else{
            
            let toast = this.toastCtrl.create({
              message: 'Fehler erzeugen des Einsatzplan',
              position: 'top',
              cssClass: 'toast-error',
              duration: 3000
            });
            toast.present();                       
            //console.log("fehler");
          }
        resolve([this.data]);          
        }, error => {
          console.log('HTTP Error, no answer');
          console.log(error);
      });
    });    
  }

  extendedep(data){
    return new Promise(resolve => {

      this.http.post(this.common.baseurl+'einsatzplane/extendedep',data)
        .subscribe(data => {
          let response = data.json();
          this.updateRequired = true;
          //console.log(data.json());
          if(response.success === true){
            this.updateRequired = true;
            this.dataextended = JSON.parse(response.data);
            //console.log(this.dataextended);
          }
          else{
            
            let toast = this.toastCtrl.create({
              message: 'Fehler beim Aktualisieren',
              position: 'top',
              cssClass: 'toast-error',
              duration: 3000
            });
            toast.present();     
                  
            //console.log("fehler");
          }
        resolve([this.data]);          
        }, error => {
          console.log('HTTP Error, no answer');
          console.log(error);
      });
    });    
  }
  
  updateextendedep(data){
    return new Promise(resolve => {

      this.http.post(this.common.baseurl+'einsatzplane/updateextendedep',data)
        .subscribe(data => {
          let response = data.json();
          this.updateRequired = true;
          if(response.success === true){
            this.updateRequired = true;
            //this.dataextended = JSON.parse(response.data);
            //console.log(this.dataextended);
          }
          else{
            
            let toast = this.toastCtrl.create({
              message: 'Fehler beim Aktualisieren',
              position: 'top',
              cssClass: 'toast-error',
              duration: 3000
            });
            toast.present();     
                  
            //console.log("fehler");
          }
        resolve([this.data]);          
        }, error => {
          console.log('HTTP Error, no answer');
          console.log(error);
      });
    });    
  }

  sotrno(pp , reason){
    return new Promise(resolve => {
      var data = JSON.stringify({
            pp: pp,
            reason: reason,
            token: this.userData.jwt
        });
    
      this.http.post(this.common.baseurl+'einsatzplane/storno',data)
        .subscribe(data => {
          let response = data.json();
          this.updateRequired = true;
          if(response.success === true){
          }
          else{
            /*
            let toast = this.toastCtrl.create({
              message: 'Login nicht erfolgreich',
              position: 'top',
              cssClass: 'toast-error',
              duration: 3000
            });
            toast.present();     
            */       
          }
        resolve([this.data]);          
        }, error => {
          console.log('HTTP Error, no answer');
          console.log(error);
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/einsatzplan-data.ts